import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

import { GraphService } from '~/core/services/graph.service';
import { AppConfigService } from '~/core/services/appconfig.service';
import { AppSettingsService } from '~/core/services/appsettings.service';
import { environment } from '../../../../../environments/environment';

import { AppSettings } from '~/core/models/appsettings';

@Component({
    selector: 'header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})

export class HeaderComponent {
    @Input() title = "SDS IntelliRev Validator";
    @Output() setLayoutCssClass = new EventEmitter();
    @Output() reloadPage = new EventEmitter();

    public appSettings: AppSettings = new AppSettings();
    public env: string = "";
    public itemsClass = "";
    public initials: string = "";
    public showPhoto: boolean = false;

    constructor(
        private router: Router,
        private graphService: GraphService,
        private appConfigService: AppConfigService,
        private appSettingsService: AppSettingsService
    ) {
        const configuredEnvironment = this.appConfigService.getConfig("environment");
        const resolvedEnvironment = (configuredEnvironment || environment.name || "").toString().trim();

        if (resolvedEnvironment) {
            this.env = resolvedEnvironment.toLocaleUpperCase();
        }
    }

    //*************************************************************************
    //  Component Life-Cycle Methods
    //*************************************************************************
    public async ngOnInit() {
        await this.getUserInfo();
    }

    //*************************************************************************
    //  Public Methods
    //*************************************************************************
    public navigateTo(url: string) {
        this.router.navigateByUrl(url);
    }

    //*************************************************************************
    //  Private Methods
    //*************************************************************************
    private async getUserInfo() {
        this.appSettings = await this.appSettingsService.getSettings();

        if (this.appSettings.user?.photo !== "") {
            this.showPhoto = true;
        } else {
            this.graphService.getUserPhoto().then((photo: any) => {
                this.appSettings.user.photo = photo;

                if (photo !== "") {
                    this.showPhoto = true;
                }
    
                this.appSettingsService.saveSettings(this.appSettings);
            });
        }
    }
}
